<via-help-resources-layout>
    <div class="e-column-layout">
        <div class="e-navigation-column">
            <div class="e-fixed-content" role="region">

                <h1 class="e-page-title">Video Tutorials</h1>
                <div class="e-video-list">
                    <ng-container *ngFor="let section of videoSections">
                        <h2 class="e-content-heading">{{ section.name }}</h2>
                        <a *ngFor="let video of section.videos" [class.e-active]="activeVideo.id === video.id"
                            (click)="setVideo(video)" tabindex="0">
                            {{ video.title }}
                        </a>
                    </ng-container>
                </div>

            </div>
        </div>
        <div class="e-content-column" role="main">

            <h2 class="e-content-heading">{{ activeVideo.title }}</h2>
            <via-video-player [video]="activeVideo"></via-video-player>

            <p>
                You can select your preferred language for each video using the player's Closed Captioning icon.
                <i class="fa-regular fa-closed-captioning"></i>
            </p>

        </div>
    </div>
</via-help-resources-layout>
